import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import styles from './styles.scss';

class ImageGrid extends React.Component {
  hasImages() {
    return this.props.images.length > 0;
  }

  gridClassName() {
    return styles[`images${this.props.images.length}Up`];
  }

  mapSrc(image) {
    const { images } = this.props;
    // If image is primary image (map), check to see if it should render
    // as a square or the default ratio
    return images.length === 2 || images.length === 5
      ? image.squareSrc
      : image.defaultSrc;
  }

  renderGrid() {
    const { images } = this.props;
    return (
      <div className={`${styles.container} ${this.gridClassName()}`}>
        {this.hasImages() &&
          images.map((image, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className={styles.imageWrapper} key={index}>
              <div className={`${styles.image} ${styles[image.type]}`}>
                <img
                  src={
                    image.type === 'map' ? this.mapSrc(image) : image.defaultSrc
                  }
                  alt={
                    image.type === 'map'
                      ? I18n.t('strava.athletes.show_public.activity_map_alt', {
                          activity_title: image.caption
                        })
                      : image.caption
                  }
                />
              </div>
            </div>
          ))}
      </div>
    );
  }

  render() {
    return this.hasImages() ? this.renderGrid() : null;
  }
}

ImageGrid.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape())
};

ImageGrid.defaultProps = {
  images: []
};

export default ImageGrid;
